import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const instagram = defineConnector({
  identifier: "instagram",
  name: "Instagram",
  tagLine: "Photo and video sharing platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () =>
    "https://(?:graph\\.instagram\\.com/.*|graph\\.facebook\\.com/.*/ig_.*)",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get an Instagram access token",
      items: [
        {
          kind: "markdown",
          content:
            "Set up an app in the [Meta Developer Portal](https://developers.facebook.com/apps/) with **Instagram Graph API** permissions. Complete the OAuth flow to obtain a long-lived access token.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://graph.instagram.com/me?fields=id,username",
  },
});
